import * as React from 'react'
import { Box } from '@mui/material'
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded'
import HandymanRoundedIcon from '@mui/icons-material/HandymanRounded'
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded'

export const resolveUnitLevelBadge = entry => {
    const directLevel = String(entry?.troopLevel ?? entry?.level ?? '').replace(/[^\d]/g, '')
    if (directLevel)
        return directLevel

    return String(entry?.statLine ?? '').match(/Level\s+([0-9]+)/i)?.[1] ?? ''
}

export default function UnitIconFrame({
    iconUrl,
    itemType = 'troop',
    level = '',
    amount = '',
    size = 100,
    sx
}) {
    const frameSize = Math.max(Number(size) || 100, 100)
    const iconSize = frameSize
    const badge = String(level ?? '').replace(/[^\d]/g, '')
    const fallbackIcon =
        itemType === 'tool' ? <HandymanRoundedIcon sx={{ fontSize: Math.max(34, frameSize - 24), color: '#d6e2f7' }} /> :
            itemType === 'resource' || itemType === 'building' ? <Inventory2RoundedIcon sx={{ fontSize: Math.max(34, frameSize - 24), color: '#d6e2f7' }} /> :
                <GroupsRoundedIcon sx={{ fontSize: Math.max(34, frameSize - 24), color: '#d6e2f7' }} />

    return (
        <Box
            sx={{
                position: 'relative',
                width: frameSize,
                height: frameSize,
                borderRadius: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                overflow: 'hidden',
                border: 0,
                backgroundColor: 'transparent',
                boxShadow: 'none',
                ...sx
            }}
        >
            {iconUrl ? (
                <Box
                    component="img"
                    src={iconUrl}
                    alt=""
                    loading="lazy"
                    sx={{
                        width: iconSize,
                        height: iconSize,
                        objectFit: 'contain',
                        imageRendering: 'auto',
                        pointerEvents: 'none'
                    }}
                />
            ) : fallbackIcon}
            {badge ? (
                <Box
                    component="span"
                    sx={{
                        position: 'absolute',
                        top: 2,
                        left: 2,
                        minWidth: 16,
                        height: 16,
                        px: 0.35,
                        borderRadius: '50%',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#2d8edb',
                        border: '1px solid rgba(255,255,255,0.92)',
                        color: '#ffffff',
                        fontWeight: 800,
                        fontSize: '0.66rem',
                        lineHeight: 1
                    }}
                >
                    {badge}
                </Box>
            ) : null}
            {amount ? (
                <Box
                    component="span"
                    sx={{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        left: 0,
                        minHeight: 13,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(228, 201, 168, 0.95)',
                        borderTop: '1px solid rgba(125, 92, 58, 0.42)',
                        color: '#23170e',
                        fontWeight: 800,
                        fontSize: '0.62rem',
                        lineHeight: 1
                    }}
                >
                    {amount}
                </Box>
            ) : null}
        </Box>
    )
}
